<div
  class="pt-2 pb-2 flex justify-between pl-9"
>
  <div class="flex flex-col">
    <span class="header-label">Most Recent Admission</span>
    <span  class="header-value">{{ getDateFormat(headerData?.mostrecentadmission) }}</span>
  </div>

  <div class="flex flex-col">
    <span class="header-label">DOB</span>
    <span class="header-value">{{ getDateFormat(headerData?.dob) }}</span>
  </div>

  <div class="flex flex-col">
    <span class="header-label">Open Therapy Episode of Care</span>

    <div class="flex flex-row">
      <span class="header-value">
        {{ headerData?.opentherapyepisode }}
      </span>
    </div>
  </div>

  <div class="flex flex-col pr-20">
    <span class="header-label">Payor</span>
    <span class="header-value">{{ headerData?.payor }}</span>
  </div>
</div>

